import { send_to_server } from '@/services/socketio_client_react/send_to_server';
import { ActionReducerMapBuilder, PayloadAction } from '@reduxjs/toolkit';
import { RequestWordsTranslateFromEnglish } from '@shared/dto/+word/word_translated/_requests/request_words_translate_from_english';
import { ENUM__network_event_client_to_server } from '@shared/network/ENUM__network_event_client_to_server';
import { createAsyncThunkSafe } from '../../_base/createAsyncThunkSafe';
import { StateWords } from '../state_words';

export const remote_words_translate_from_english = createAsyncThunkSafe<void, RequestWordsTranslateFromEnglish[]>(
  ENUM__network_event_client_to_server.WORDS_TRANSLATE_FROM_ENGLISH,
  async (request): Promise<void> => {
    await send_to_server(ENUM__network_event_client_to_server.WORDS_TRANSLATE_FROM_ENGLISH, request);
  },
);

export function init_remote_words_translate_from_english(builder: ActionReducerMapBuilder<StateWords>) {
  builder
    .addCase(remote_words_translate_from_english.pending, (state, action) => {})
    .addCase(remote_words_translate_from_english.rejected, (state, action) => {})
    .addCase(remote_words_translate_from_english.fulfilled, (state, action: PayloadAction) => {});
}
